export default __webpack_public_path__ + "static/media/小喵宠.e0b402de.png";